var _defs, _g, _polygon, _polygon2, _polyline, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobLockheedShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #35202f;\n      }\n\n      .cls-2 {\n        fill: #301d29;\n      }\n\n      .cls-3 {\n        fill: #261722;\n      }\n\n      .cls-4 {\n        fill: #ff0068;\n      }\n\n      .cls-5 {\n        fill: #3f2738;\n      }\n\n      .cls-6 {\n        fill: #5b4956;\n      }\n\n      .cls-7 {\n        fill: #d8ced0;\n      }\n\n      .cls-8 {\n        fill: #d60061;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "268.93 392.83 179.82 392.83 190.69 389.57 258.06 389.57 268.93 392.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "268.93 392.83 179.82 392.83 190.69 396.09 258.06 396.09 268.93 392.83"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "536.43 383.98 510.69 387.85 457.1 387.85 457.1 342.24 536.43 354.15 536.43 383.98"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "536.43 324.01 545.77 254.4 264.76 342.49 111.53 389.21 231.07 409.86 458.39 409.86 536.43 324.01"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "536.43 324.01 558.81 273.96 264.76 342.49"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "459.28 409.86 231.07 409.86 111.53 389.21 476.67 389.21 459.28 409.86"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "534.26 452.24 360.39 437.03 349.52 422.9 529.91 440.29 534.26 452.24"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "402.77 420.73 270.19 413.12 270.19 407.69 402.77 400.08 402.77 420.73"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "529.51 440.29 349.11 422.9 327.38 389.21 476.22 389.15 529.51 440.29"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "465.35 328.3 535.99 323.95 562.07 295.7 264.31 342.43 465.35 328.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobLockheedShip);
export default __webpack_public_path__ + "static/media/mob-lockheed-ship.cfe8988b9e0831ac9877db5d1abedee3.svg";
export { ForwardRef as ReactComponent };